<cw-full-screen-loader></cw-full-screen-loader>

<div class="twc-main-container">
    <cw-brand-bar></cw-brand-bar>
    <cw-topbar *ngIf="showTopbar"></cw-topbar>
    <div class="twc-content-container" *ngIf="showContent">
        <cw-sidebar *ngIf="showSidebar"></cw-sidebar>
        <div class="twc-content" [hidden]="appSharedService.loading && !appSharedService.keepBackgroundVisible">
            <div class="twc-content-area twc-p-0 twc-d-flex flex-direction-column">
                <router-outlet></router-outlet>
                <cw-footer *ngIf="showFooter"></cw-footer>
            </div>
        </div>
    </div>
</div>